import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, totalSteps }) => {
  const steps = [
    { number: 1, title: 'Bedrijfsgegevens', description: 'Basis informatie' },
    { number: 2, title: 'Diensten', description: 'Service categorieën' },
    { number: 3, title: 'Werkgebied', description: 'Service locaties' },
    { number: 4, title: 'Documenten', description: 'Certificaten & vergunningen' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-8 shadow-[0_8px_24px_-4px_rgba(0,0,0,0.12)] hover:shadow-[0_12px_32px_-8px_rgba(0,0,0,0.15)] transition-all duration-300">
      <div className="flex items-center justify-between">
        {steps?.map((step, index) => (
          <React.Fragment key={step?.number}>
            <div className="flex flex-col items-center">
              {/* Step Circle */}
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all shadow-[0_4px_14px_0_rgba(0,0,0,0.1)] hover:shadow-[0_6px_20px_rgba(0,0,0,0.15)] hover:-translate-y-1 transform duration-300 ${
                  step?.number < currentStep
                    ? 'bg-success border-success text-success-foreground shadow-[0_4px_14px_0_rgba(16,185,129,0.3)]'
                    : step?.number === currentStep
                    ? 'bg-primary border-primary text-primary-foreground shadow-[0_4px_14px_0_rgba(59,130,246,0.3)]'
                    : 'bg-muted border-border text-muted-foreground'
                }`}
              >
                {step?.number < currentStep ? (
                  <Icon name="Check" size={16} />
                ) : (
                  <span className="text-sm font-medium">{step?.number}</span>
                )}
              </div>
              
              {/* Step Info */}
              <div className="mt-2 text-center">
                <div
                  className={`text-sm font-medium ${
                    step?.number <= currentStep ? 'text-foreground' : 'text-muted-foreground'
                  }`}
                >
                  {step?.title}
                </div>
                <div className="text-xs text-muted-foreground hidden sm:block">
                  {step?.description}
                </div>
              </div>
            </div>
            
            {/* Connector Line */}
            {index < steps?.length - 1 && (
              <div
                className={`flex-1 h-0.5 mx-4 ${
                  step?.number < currentStep ? 'bg-success' : 'bg-border'
                }`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;